import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const fullName = ({ title, firstName, middleName, lastName }) =>
  `${title || ''} ${firstName || ''} ${middleName || ''} ${lastName || ''}`;
const PersonalInfo = ({ data }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Personal Info</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td />
        <td>
          <span className="subheader">Name: </span>
          <span>{fullName(data)}</span>
          {data.mobileNumber && (
            <>
              <span className="subheader">User Mobile: </span>
              <span>{data.mobileNumber}</span>
            </>
          )}
          {data.workNumber && (
            <>
              <span className="subheader">User Work Number: </span>
              <span>{data.workNumber}</span>
            </>
          )}
          {data.email && (
            <>
              <span className="subheader">User Email: </span>
              <span className="text-transform-none">{data.email}</span>
            </>
          )}
          {data.primaryLanguage && (
            <>
              <span className="subheader">Primary Language: </span>
              <span>{data.primaryLanguage}</span>
            </>
          )}
          {data.secondaryLanguage && (
            <>
              <span className="subheader">Secondary Language: </span>
              <span>{data.secondaryLanguage}</span>
            </>
          )}
          {data.birthDate && (
            <>
              <span className="subheader">DOB: </span>
              <span>{data.birthDate}</span>
            </>
          )}
          {data.timezone && (
            <>
              <span className="subheader">Timezone: </span>
              <span>{data.timezone}</span>
            </>
          )}
        </td>
      </tr>
    </tbody>
  </Table>
);

PersonalInfo.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PersonalInfo;
